/* eslint-disable react/prop-types */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faFileWord } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';

function Publications(props) {
  const {
    pubs, errorStatus, sucessStatus,
  } = props;

  const [numofItems, setNumofItems] = React.useState(4);

  const handleShowMore = () => {
    setNumofItems(numofItems + 4);
  };

  let content;
  if (sucessStatus) {
    content = pubs.slice(0, numofItems).map((pub) => {
      const fileExtension = pub.guid.slice(pub.guid.lastIndexOf('.'));
      const fileIcon = fileExtension === '.pdf' ? faFilePdf : faFileWord;
      return (
        <li
          key={pub.id}
          className="md:w-1/5 w-2/5 border border-gray-300 hover:bg-blue-400 hover:border-0 hover:text-white p-2 xl:px-6"
        >
          <a target="_blank" href={`docs/${pub.guid}`} rel="noreferrer">
            <FontAwesomeIcon
              className="lg:mt-6 mt:3 text-white bg-blue-700 p-3 rounded-xl"
              icon={fileIcon}
            />
            <p className="font-bold xl:text-xl lg:text-lg md:text-md text-sm py-3 md:w-3/4 w-full">{pub.post_title}</p>
            <p className="text-gray-600 text-xs">
              {`Published on ${new Date(pub.post_date).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
              })}`}
            </p>
          </a>
        </li>
      );
    });
    if (numofItems < pubs.length) {
      content.push(
        <button
          type="button"
          key={numofItems}
          className="bg-blue-500 hover:bg-blue-700 text-white xl:text-xl lg:text-md md:text-sm text-xs py-2 md:px-4 px-2 md:mb-4 mb-2 xl:w-1/4 lg:w-1/3 w-full"
          onClick={handleShowMore}
        >
          See More . . .
        </button>,
      );
    }
  } else if (errorStatus) {
    content = (
      <li className="w-1/4 border border-gray-300 hover:bg-amber-400 hover:border-0 p-2 px-6">
        <p className="text-gray-600 text-sm">An error occurred while fetching the publications</p>
      </li>
    );
  }

  return (
    <div id="publications" className="xl:mx-24 md:m-16 m-4">
      <h2 className="md:text-3xl text-xl text-center font-bold my-3">
        Latest Publications
      </h2>
      <ul className="md:my-8 my-4 flex xl:gap-4 gap-2 flex-wrap xl:justify-between justify-around">{content}</ul>
    </div>
  );
}

PropTypes.Publications = {
  pubs: PropTypes.isRequired,
  errorStatus: PropTypes.bool.isRequired,
  sucessStatus: PropTypes.bool.isRequired,
  error: PropTypes.string.isRequired,
};

export default Publications;
